module.exports = __webpack_public_path__ + "img/success.74641493.png";